<template>
  <div class="item-component">
    <div class="s-item-title">
      <h4 class="chart-title">
        <i class="el-icon-s-grid"></i>
        新生报到人数
      </h4>
    </div>
    <chart-two style="height: 90%" :value="chartData"></chart-two>
  </div>
</template>

<script>
import ChartTwo from "../charts/chart02";
import { chartData02 } from "@/assets/json/chartData.js";
import { mapState } from "vuex";
export default {
  components: {
    ChartTwo,
  },
  data() {
    return {
      chartData: [],
      enrollmentYear: "", // 入学年份
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE", "_CURRENTYEAR","_CURRENT_ACADEMIC"]),
  },
  created() {
    this.enrollmentYear = this._CURRENTYEAR[0].value;
    this.getPrediectData();
  },
  mounted() {},
  methods: {
    // 获取新生预报到情况数据
    getPrediectData() {
      let params = { enrollmentYear: this.enrollmentYear, academicDegree: this._CURRENT_ACADEMIC };
      this.$http
        .get("/welcome-forecast/statistics/getForecastNum", { params })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            // console.log(res);
            let data = res.data;
            this.chartData = [
              { value: data.doneNum, name: "已完成" },
              { value: data.todoNum, name: "未完成" },
            ];
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>
